import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  Button,
  Box,
  Grid,
  Collapse,
  IconButton,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  NavigateNext as NextIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import AutoPlusReview from './components/AutoPlusReview';
import MVRReview from './components/MVRReview';
import ApplicationReview from './components/ApplicationReview';
import QuoteReview from './components/QuoteReview';

const ReviewSection = ({ title, children }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <Box sx={{ mb: 3 }}>
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center',
          cursor: 'pointer',
          '&:hover': { opacity: 0.8 },
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Typography 
          variant="h5" 
          sx={{ 
            color: '#1565c0',
            fontWeight: 500,
            flex: 1,
          }}
        >
          {title}
        </Typography>
        <IconButton size="small">
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>
      <Collapse in={expanded}>
        <Box sx={{ mt: 2 }}>
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};

const Verif = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl">
      {/* Hero Section */}
      <Box sx={{ 
        pt: 4,
        pb: 3,
        textAlign: 'center',
        position: 'relative',
        borderBottom: '1px solid #e0e0e0',
        mb: 4
      }}>
        <Button
          variant="outlined"
          onClick={() => navigate('/upload')}
          startIcon={<ArrowBackIcon />}
          sx={{
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#1976d2',
            borderColor: '#1976d2',
            '&:hover': {
              borderColor: '#1565c0',
              backgroundColor: 'rgba(25, 118, 210, 0.04)'
            }
          }}
        >
          Back to Upload
        </Button>

        <Typography 
          variant="h4" 
          sx={{ 
            color: '#1976d2',
            fontWeight: 600,
            mb: 1
          }}
        >
          Document Verification
        </Typography>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            color: '#666',
            maxWidth: '600px',
            mx: 'auto'
          }}
        >
          Review and verify all uploaded documents for accuracy and completeness
        </Typography>

        {/* Generate Report Button */}
        <Button
          variant="contained"
          endIcon={<NextIcon />}
          onClick={() => navigate('/report')}
          sx={{
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            backgroundColor: '#1976d2',
            '&:hover': {
              backgroundColor: '#1565c0',
            },
          }}
        >
          Generate Report
        </Button>
      </Box>

      {/* Insurance Documents Section */}
      <ReviewSection title="Insurance Documents Review">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box 
              sx={{ 
                p: 3, 
                borderRadius: 2,
                backgroundColor: '#f8f9fa',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              <QuoteReview />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box 
              sx={{ 
                p: 3, 
                borderRadius: 2,
                backgroundColor: '#f8f9fa',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              <ApplicationReview />
            </Box>
          </Grid>
        </Grid>
      </ReviewSection>

      {/* Record Verification Section */}
      <ReviewSection title="Record Verification">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box 
              sx={{ 
                p: 3, 
                borderRadius: 2,
                backgroundColor: '#f8f9fa',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              <MVRReview />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box 
              sx={{ 
                p: 3, 
                borderRadius: 2,
                backgroundColor: '#f8f9fa',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              <AutoPlusReview />
            </Box>
          </Grid>
        </Grid>
      </ReviewSection>
    </Container>
  );
};

export default Verif; 